export default __webpack_public_path__ + "static/fire_pump_b.668fc7d081d79743460c0aebc2c2e9b7.svg";